/**
 * SAIYANS — Custom Fight Poster product template
 * Encapsulated under window.Saiyans. No global leakage.
 */
window.Saiyans = window.Saiyans || {};

(function (NS) {
  'use strict';

  var root = document.body;
  if (!root || !document.querySelector('.saiyans-page')) return;

  NS.state = { basePrice: 0, deliveryFee: 0 };

  function formatMoney(cents) {
    var priceEl = root.querySelector('[data-saiyans-live-price]');
    var format = priceEl ? priceEl.getAttribute('data-money-format') : null;
    var amount = (cents / 100).toFixed(2);
    return format ? format.replace('{{amount}}', amount) : amount;
  }

  function updateLivePrice() {
    var total = NS.state.basePrice + NS.state.deliveryFee;
    var targets = root.querySelectorAll('[data-saiyans-live-price]');
    targets.forEach(function (el) { el.textContent = formatMoney(total); });
  }

  NS.initHeroGallery = function () {
    var slides = root.querySelectorAll('[data-saiyans-hero-slide]');
    var dots = root.querySelectorAll('[data-saiyans-hero-dot]');
    if (!slides.length) return;

    function showSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); });
    });
  };

  NS.initPackageSelector = function () {
    var cards = root.querySelectorAll('[data-saiyans-package-card]');
    var variantInput = root.querySelector('[data-saiyans-variant-id]');
    if (!cards.length) return;

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');

      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      var priceCents = parseInt(card.getAttribute('data-price-cents') || '0', 10);
      var variantId = card.getAttribute('data-variant-id');

      NS.state.basePrice = priceCents;
      updateLivePrice();

      if (variantId && variantInput) {
        variantInput.value = variantId;
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    var initial = root.querySelector('[data-saiyans-package-card].is-selected') || cards[0];
    if (initial) {
      NS.state.basePrice = parseInt(initial.getAttribute('data-price-cents') || '0', 10);
    }
  };

  NS.initDeliverySelector = function () {
    var cards = root.querySelectorAll('[data-saiyans-delivery-card]');
    var deliveryInput = root.querySelector('[data-saiyans-delivery-input]');
    if (!cards.length) return;

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      var feeCents = parseInt(card.getAttribute('data-fee-cents') || '0', 10);
      NS.state.deliveryFee = feeCents;
      updateLivePrice();

      if (deliveryInput) {
        deliveryInput.value = card.getAttribute('data-delivery-value') || '';
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });

    var initial = root.querySelector('[data-saiyans-delivery-card].is-selected') || cards[0];
    if (initial) {
      NS.state.deliveryFee = parseInt(initial.getAttribute('data-fee-cents') || '0', 10);
    }
  };

  NS.initStickyAtc = function () {
    var sticky = root.querySelector('[data-saiyans-sticky-atc]');
    var trigger = root.querySelector('[data-saiyans-sticky-trigger]');
    if (!sticky || !trigger || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  };

  NS.initCountdown = function () {
    var container = root.querySelector('[data-saiyans-countdown]');
    if (!container) return;
    var endAttr = container.getAttribute('data-end');
    var end = endAttr ? new Date(endAttr).getTime() : NaN;
    if (isNaN(end)) {
      end = Date.now() + (18 * 3600000) + (1 * 60000) + (45 * 1000);
    }
    var hEl = container.querySelector('[data-unit="h"]');
    var mEl = container.querySelector('[data-unit="m"]');
    var sEl = container.querySelector('[data-unit="s"]');
    if (!hEl || !mEl || !sEl) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        hEl.textContent = '00';
        mEl.textContent = '00';
        sEl.textContent = '00';
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  };

  NS.initPortfolioSlider = function () {
    var track = root.querySelector('[data-saiyans-portfolio-track]');
    var prevBtn = root.querySelector('[data-saiyans-portfolio-prev]');
    var nextBtn = root.querySelector('[data-saiyans-portfolio-next]');
    var filters = root.querySelectorAll('[data-saiyans-portfolio-filter]');
    var dotsContainer = root.querySelector('[data-saiyans-portfolio-dots]');
    if (!track) return;

    function visibleItems() {
      return Array.prototype.filter.call(
        track.querySelectorAll('[data-saiyans-portfolio-item]'),
        function (item) { return !item.hidden; }
      );
    }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var items = visibleItems();
      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'saiyans-hero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () {
          item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });
    }

    function updateActiveDot() {
      if (!dotsContainer) return;
      var items = visibleItems();
      var dots = dotsContainer.querySelectorAll('.saiyans-hero__dot');
      var trackRect = track.getBoundingClientRect();
      var closestIndex = 0;
      var closestDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.getBoundingClientRect().left - trackRect.left);
        if (dist < closestDist) { closestDist = dist; closestIndex = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closestIndex); });
    }

    function scrollByAmount(dir) {
      var item = track.querySelector('.saiyans-portfolio__item:not([hidden])');
      var amount = item ? item.offsetWidth : 300;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });
    track.addEventListener('scroll', function () {
      window.clearTimeout(track._saiyansScrollTimer);
      track._saiyansScrollTimer = window.setTimeout(updateActiveDot, 100);
    });

    if (filters.length) {
      var items = track.querySelectorAll('[data-saiyans-portfolio-item]');
      filters.forEach(function (filterBtn) {
        filterBtn.addEventListener('click', function () {
          filters.forEach(function (f) { f.classList.remove('is-active'); });
          filterBtn.classList.add('is-active');
          var category = filterBtn.getAttribute('data-saiyans-portfolio-filter');

          items.forEach(function (item) {
            var itemCategory = item.getAttribute('data-category');
            var show = category === 'all' || itemCategory === category;
            item.hidden = !show;
          });
          buildDots();
        });
      });
    }

    buildDots();
  };

  NS.initFaqAccordion = function () {
    var items = root.querySelectorAll('[data-saiyans-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('[data-saiyans-faq-q]');
      var panel = item.querySelector('[data-saiyans-faq-a]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherPanel = other.querySelector('[data-saiyans-faq-a]');
          var otherBtn = other.querySelector('[data-saiyans-faq-q]');
          if (otherPanel) otherPanel.style.maxHeight = null;
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };

  function init() {
    NS.initHeroGallery();
    NS.initPackageSelector();
    NS.initDeliverySelector();
    NS.initStickyAtc();
    NS.initPortfolioSlider();
    NS.initFaqAccordion();
    NS.initCountdown();
    updateLivePrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window.Saiyans);
